import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Company } from '@core/interfaces';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { sentry } from 'sentry';
import { searchManyInputStyles } from '../../base/fc-search-many-input/fc-search-many-input.component';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';

const SEARCH_QUERY = gql`
  query searchCompanies($where: CompanyWhereInput, $limit: Int, $offset: Int) {
    companies(
      where: $where
      orderBy: name_asc
      limit: $limit
      offset: $offset
    ){
      items {
        id
        name
      }
    }
  }
`;

@Component({
  selector: 'fc-companies-input',
  templateUrl: './fc-companies-input.component.html',
  styleUrls: ['./fc-companies-input.component.scss']
})
export class FcCompaniesInputComponent {

  @Input()
  public control: FormControl;

  @Input()
  public desiredStyle?: searchManyInputStyles = searchManyInputStyles.Select;

  constructor(
    private fuseTranslationLoaderService: FuseTranslationLoaderService,
    private apollo: Apollo
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
    this.search = this.search.bind(this);
    this.displayWith = this.displayWith.bind(this);
  }

  async search(searchTerm: string, limit: number, offset: number): Promise<Company[]> {
    return this.apollo
      .query({
        query: SEARCH_QUERY,
        variables: {
          where: {
            name_contains: searchTerm,
            archived: false
          },
          limit: limit,
          offset: offset
        },
      })
      .toPromise()
      .then((result) => {
        return result.data['companies']['items'];
      })
      .catch((err) => {
        sentry.captureException(err);
        return [];
      });
  }

  displayWith(value: Company): string {
    return value && value.name;
  }

}
